import {
  RecordsUtilsService,
  vsName as RecordsUtilsServiceName,
} from "../../records/utils";
import { MachineEpromConfiguration } from "./models/machineConfiguration";

export const vsServiceName = "sobobaUtilsService";

export class SobobaUtilsService {
  static $inject = [RecordsUtilsServiceName];
  constructor(private readonly recordUtilsService: RecordsUtilsService) {}

  private getDefaultEproms(): MachineEpromConfiguration[] {
    const defaultItems = [
      {
        Id: 0,
        EpromLabel: "Game Version",
      },
      {
        Id: 0,
        EpromLabel: "Operating System",
      },
      {
        Id: 0,
        EpromLabel: "Bios/Boot/Comm",
      },
      {
        Id: 0,
        EpromLabel: "Bill Validator",
      },
      {
        Id: 0,
        EpromLabel: "Printer",
      },
      {
        Id: 0,
        EpromLabel: "Misc. Software versions",
      },
    ];

    defaultItems.forEach((i) => this.recordUtilsService.assignId(i));

    return defaultItems;
  }

  isDefaultEprom(eprom: MachineEpromConfiguration): boolean {
    return !!this.getDefaultEproms().find(
      (de) => de.EpromLabel === eprom.EpromLabel
    );
  }

  normalizeEproms(
    eproms: MachineEpromConfiguration[]
  ): MachineEpromConfiguration[] {
    const defaultEproms = this.getDefaultEproms();
    return [
      ...defaultEproms.map(
        (defaultEprom) =>
          eproms?.find((e) => e.EpromLabel == defaultEprom.EpromLabel) ??
          defaultEprom
      ),
      ...(eproms?.filter(
        (e) => !defaultEproms.find((de) => de.EpromLabel === e.EpromLabel)
      ) ?? []),
    ];
  }
}
